import React from 'react';
import Head from 'next/head';
import '@styles/styles.scss';
import Toast from '@libs/toast';
import '@styles/applications.scss';
import 'react-phone-number-input/style.css';
import { WidgetProvider } from '@contexts/Widget';
import { LocaleProvider } from '@contexts/Locale';
import { QueueFindProvider } from '@contexts/QueueFind';
import { JsonFormProvider } from '@contexts/JsonSchema/jsonForm';
import config from '@root/config';

export default class Layout extends React.Component {
    state = {
        hasError: false
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    
    componentDidCatch(error) {
        Toast.show(error.toString(), 'error', 3000);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div
                    className="snap"
                    onKeyPress={() => {}}
                    onClick={() => {
                        this.showReportDialog();
                    }}>
                    <p>{`We're sorry — something's gone wrong.`}</p>
                    <p>Our team has been notified, but click here fill out a report.</p>
                </div>
            );
        }
        return (
            <React.Fragment>
                <Head>
                    <title>{ this.props.title }</title>
                    <meta charSet='utf-8' />
                    <meta name='viewport' content='initial-scale=1.0, width=device-width' />

                    <link rel="stylesheet" href={`${config.folder}static/assets/css/ionicons.min.css`} />
                    <link rel="stylesheet" href={`${config.folder}static/assets/css/bootstrap.min.css`} />
                    <link rel="stylesheet" href={`${config.folder}static/assets/css/bootstrap-select.min.css`} />
                </Head>
                <WidgetProvider initialState={this.props.initialState}>
                    <JsonFormProvider initialState={this.props.initialState}>
                        <QueueFindProvider initialState={this.props.initialState}>
                            <LocaleProvider initialState={this.props.initialState}>
                                { this.props.children }
                            </LocaleProvider>
                        </QueueFindProvider>
                    </JsonFormProvider>
                </WidgetProvider>
            </React.Fragment>
        );
    }
}